module.exports = __webpack_public_path__ + "static/media/AV.0df90a91.svg";